import { Injectable } from '@angular/core';
import { Observable, throwError } from 'rxjs';
import { catchError } from 'rxjs/operators';
import { HttpClient, HttpHeaders } from '@angular/common/http';
import { ConfigClass } from "./../config";

@Injectable({
    providedIn: 'root'
})
export class ComplainsService {

    // Base url
    baseurl = ConfigClass.getEndpoint;

    // get token fromm storage
    token = JSON.parse(sessionStorage.getItem('currentUser'));

    // Http Headers
    httpOptions = {
        headers: new HttpHeaders({
        })
    }

    constructor(private http: HttpClient) {

        this.httpOptions.headers = this.httpOptions.headers.set('Authorization',
            'bearer ' + this.token);

        this.httpOptions.headers = this.httpOptions.headers.set('Content-Type',
            'application/json');
    }

    // GET
    getComplains(filters): Observable<any> {
        let query = "";
        if (filters.status) {
            query = "&status=" + filters.status;
        }
        return this.http.get(this.baseurl + '/complains/all?department=' +
            filters.department.toUpperCase() +
            filters.projectId +
            "&fromDate=" +
            filters.fromDate +
            "&toDate=" +
            filters.toDate +
            "&pageNumber=" +
            filters.page +
            "&pageSize=" +
            filters.size +
            "&unitNumber=" +
            filters.unitNumber +
            "&subDepartment=" + filters.subDepartment +
            query +
            "&sort=createdDate,desc", this.httpOptions)
            .pipe(
                catchError(this.errorHandl)
            )
    }

    getComplainUpdates(id) {
        return this.http.get(this.baseurl + '/complains/' + id + '/updates', this.httpOptions)
            .pipe(
                catchError(this.errorHandl)
            )
    }

    updateComplain(payload, id) {
        return this.http
            .put(
                this.baseurl + "/complains/" + id,
                payload,
                this.httpOptions
            )
            .pipe(
                catchError(this.errorHandl)
            );
    }

    sendMessageToAgent(payload, id) {
        return this.http
            .post(
                this.baseurl + '/complains/' + id + '/updates',
                payload,
                this.httpOptions
            )
            .pipe(
                catchError(this.errorHandl)
            );
    }

    updateAckhnolegde(id, ackId) {
        return this.http
            .put(
                this.baseurl + '/complains/' + id + '/updates/' + ackId + "/ack",
                {},
                this.httpOptions
            )
            .pipe(
                catchError(this.errorHandl)
            );
    }

    rollbackComplain(complainId, payload) {
        return this.http
            .post(
                this.baseurl + '/complains/' + complainId + '/rollbacks',
                payload,
                this.httpOptions
            )
            .pipe(
                catchError(this.errorHandl)
            );
    }

    getComplainRollbackHistory(id) {
        return this.http.get(this.baseurl + '/complains/' + id + '/rollbacks', this.httpOptions)
            .pipe(
                catchError(this.errorHandl)
            )
    }
    // Error handling
    errorHandl(error) {
        let errorMessage = '';
        if (error.error instanceof ErrorEvent) {
            // Get client-side error
            errorMessage = error.error.message;
        } else {
            // Get server-side error
            errorMessage = `Error Code: ${error.status}\nMessage: ${error.message}`;
        }
        return throwError(errorMessage);
    }
}
